<template>
    <div class="app-inner" id="fzpaper">
         <div class="public-btn-div flex align-cen">
            <div class="public-add" @click="addRaso">
            新增仿真试卷 
      </div>
         </div>
          <div class="p-tit-c">
            <div class="businessList-filter">
                    <div class="businessList-filter-list flex align-cen">
                     <div class="fl-le flex align-cen">
          <div class="label">仿真试卷名称：</div>
          <div class="el-select1">
            <el-input placeholder="请输入试卷名称" v-model="search" clearable> </el-input>
          </div>
         </div>
          <div class="fl-rt flex align-cen">
          <div class="label">试卷ID：</div>
          <div class="el-select1">
          <el-input placeholder="请输入试卷ID" v-model="search1" clearable> </el-input>
          </div>
         </div>
              </div> 
              <div class="businessList-filter-list flex align-cen">
                  <div class="fl-le flex align-cen">
                      <div class="label">关联仿真应用：</div>
                        <el-select
                        v-model="value1"
                        clearable
                        placeholder="请选择"
                        @change="classSelect"
                    >
                        <el-option
                        v-for="item in options"
                          :key="item.id"
                        :label="item.appName === '未分类' ? '未分类' : item.appName"
                        :value="item.id"
                        >
            </el-option>
          </el-select>
                  </div>
              </div>
                 <div class="businessList-filter-list flex align-cen">
                        <div class="label">有效期限：</div>
                        <div
                        style="color: red; padding-right: 20px; cursor: pointer"
                        @click="allradio(0)"
                        >
                        不限
                        </div>
                        <el-radio v-model="radio" label="1" @change="classSelect" >有时间限制</el-radio>
                        <el-radio v-model="radio" label="2" @change="classSelect">无时间限制</el-radio>
                    </div>
                <div class="businessList-filter-list flex align-cen">
                    <div class="label">试卷状态：</div>
                    <div
                    style="color: red; padding-right: 20px; cursor: pointer"
                    @click="allradio(1)"
                    >
                    不限
                    </div>
                     <el-radio v-model="radio1" label="0" @change="classSelect" >未开始</el-radio>
                    <el-radio v-model="radio1" label="1" @change="classSelect" >考试中</el-radio>
                    <el-radio v-model="radio1" label="2" @change="classSelect">未考试</el-radio>
                </div>
                    <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="classSelect">
        搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
        重置筛选条件 
        </div>
      </div>
            </div>
          </div>
                <div class="businessList-container">
        <div class="businessList-container-table">
                  <el-table
            :data="list"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
                <el-table-column label="试卷封面" align="center" prop="pic"  width="200">
            <template slot-scope="scope" >
                <img :src="scope.row.logo ? scope.row.logo : require('../../assets/images/nullimg.png')" alt="" style="display: block;width:50%;margin:0 auto" v-if="scope.row.id !=0"> 
            </template>
         </el-table-column>
          <el-table-column prop="id" label="试卷ID" align="center" width="200">
          </el-table-column>
          <el-table-column prop="paperName" label="试卷名称" align="center" width="300">
          </el-table-column>
              <el-table-column prop="" label="关联仿真应用" align="center" width="300">
             <template slot-scope="scope">
              <div>
                {{scope.row.appName || '-'}}
              </div>
             </template>
          </el-table-column>
           <el-table-column prop="examNum" label="考试人次" align="center" width="150">
          </el-table-column>
           <el-table-column prop="" label="考试时间" align="center" >
             <template slot-scope="scope">
              <div>
                {{scope.row.answerTimeLimit ? `${scope.row.answerTimeLimit}分钟` : '-'}}
              </div>
             </template>
          </el-table-column>
           <el-table-column prop="processNum" label="过程数" align="center" width="150">
          </el-table-column>
            <el-table-column prop="stepNum" label="步骤数" align="center"  width="150">
          </el-table-column>
            <el-table-column label="状态" align="center" width="200"> 
            <template slot-scope="scope">
            <el-button type="warning" plain v-if="scope.row.state == '0'">未开始</el-button>
            <el-button type="danger" plain v-if="scope.row.state == '1'">考试中</el-button>
              <el-button type="info" plain v-if="scope.row.state == '2'">已考完</el-button>
            </template>
          </el-table-column>
            <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="300"
            >
             <template slot-scope="scope">
                     <el-button type="text" size="small"  slot="reference" style="color:red" v-if="scope.row.state == '1'" @click="changeStatus(scope)">停止考试</el-button>
                   <el-button type="text" size="small"  slot="reference" style="color:red" v-if="scope.row.state == '2'" @click="changeStatus(scope)">重新开考</el-button>
                  <el-button type="text" size="small"  slot="reference" style="color:red" @click="openscoreAnalysis(scope.row)">统计分析</el-button>
                   <el-button type="text" size="small"  slot="reference" style="color:red" @click="addRaso(scope.row)">编辑试卷</el-button>
                    <el-button type="text" size="small"  slot="reference" style="color:red" @click="openmoniToring(scope.row)">考试监控</el-button>
                      <el-button type="text" size="small"  slot="reference" style="color:red" @click="deleteEmPaper(scope.row)">删除</el-button>
             </template>
          </el-table-column>
        </el-table>
                   <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
        </div>
                </div>
                              <!-- 重新开考 -->
                   <el-dialog
                title="重新开考"
                :visible.sync="centerDialogVisible"
                width="30%"
                :append-to-body="true"
                center
                >
                    <div class="forminfo">
                        <div class="setdia-check">
                               <div class="settings-box">
                        <div class="settings-box-tips flex align-cen">
                            <div class="red-div"></div>
                            <p class="red-div-p">有效期限</p>
                        </div>
                          <div class="settings-box-radio flex align-cen" style="padding-bottom:20px">
                             <el-radio v-model="validPeriod" label="1">试卷开放时间</el-radio>
                              <el-date-picker
                                v-model="timevalue1"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="pickerOptions2"
                                @change="classSelect1"
                                >
                                </el-date-picker>
                        </div>
                        <div class="settings-box-radio flex align-cen">
                             <el-radio v-model="validPeriod" label="2">永久有效</el-radio>
                        </div>
                    </div>
                        </div>
                 <div class="businessList-filter-list flex align-cen public-btn-small" style="justify-content:center;padding-left:0px">
                         <div class="public-btn-small-plan" style="margin-right:30px" @click="centerDialogVisible = false">
                        取消
                        </div>
                          <el-button type="primary" class="public-btn-small-primary public-btn-small-load"
                            @click.stop="submit"
                            >
                              确定
                            </el-button>
                    </div>
                    </div>
                   </el-dialog>
    </div>
</template>
<script>
import {getTeacherAppList,getEmuPaper,editEmuPaper,EmuPaperDetail} from "@/api/enterprise/index"   //关联仿真系统、分页查询试卷列表、修改试卷、删除试卷
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    data () {
        return {
            timevalue1:[],
            showFromTime:'',
            showUntilTime:'',
            validPeriod:'1',
            options:[],
            search:'',
            search1:'',
            search2:'',
            value1:'',
            options:[],
            radio:'',
            radio1:'',
            list:[],
            totalCount:0,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            businessInfo:{},
            dataProp:{},
            centerDialogVisible:false,
            pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        }
    },
    components:{
      paginaTion
    },
    activated(){
        this.getEmuPaperList()
    },
    created() {
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.getApplist()
    },
    methods: {
      // 删除仿真试卷
      deleteEmPaper(data){
          if(data.isPlat == 1){
             return this.$util.Notifi('平台端试卷不允许删除','error','fa-exclamation-circle')
          }
         this.$confirm('您确定要删除该试卷吗？删除后该试卷考试记录也会被删除，请您谨慎操作', '删除试卷', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
              }).then(() => {
                  EmuPaperDetail({id:data.id},'DELETE')
                  .then(res =>{
                  if(res.code == 0){
                      this.$util.Notifi('删除成功','success','fa-check')
                   this.getEmuPaperList()
                    }else{
                      this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
                  })
              }).catch(() => {          
              });
      },
         // 打开考试监控
      openmoniToring(data){
        this.$router.push({
            name: "enRasoMoniToring",
            query:{
                id:data.id,
                type:1
            }
           })
      },
           // 打开统计分析
      openscoreAnalysis(data){
        this.$router.push({
            name: "enRasoAnalysis",
            query:{
                id:data.id,
            }
           })
      },
        // 关联仿真应用
          getApplist(){
            getTeacherAppList({
               id:this.businessInfo.id,
                accountId:''
              })
            .then(res => {
              this.options = res.data
            })
            .catch(err => {
            })
        },
        // 仿真试卷
        addRaso(data){
             if(data.isPlat == 1){
             return this.$util.Notifi('平台端试卷不允许修改','error','fa-exclamation-circle')
          }
         this.$router.push({
            name: "addEnRaso",
            query:{
                id:data.id,
            }
           })
            // data.id ? this.$router.push({name:'addEnRaso',query:{id:data.id}}) : this.$router.push({name:'addEnRaso',query:{}})
        },
             // 筛选
        classSelect(){
            this.currentPage = 1
            this.getEmuPaperList()
        },
          classSelect1(){
             this.showFromTime = this.timevalue1[0]
            this.showUntilTime = this.timevalue1[1]
        },
        reset(){
             this.search=""
          this.search1=""
          this.value1=""
          this.radio1=""
          this.radio=""
          this.currentPage=1
          this.getEmuPaperList()
        },
              emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getEmuPaperList()
      },
      allradio(type){
          type == 1 ? this.radio1="" : this.radio=""
          this.currentPage=1
          this.getEmuPaperList()
        },
            // 应用状态改变
    changeStatus(e){
      if(e.row.isPlat == 1){
             return this.$util.Notifi('平台端试卷不允许修改','error','fa-exclamation-circle')
          }
     if(e.row.state == 1){
           this.$confirm('确定停止考试吗？', '停止考试', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        this.editPaper(e)
                        }).catch(() => {          
                        });
        }else{
            this.dataProp = e
            this.centerDialogVisible = true
        }
      },
        submit(){
        if(this.validPeriod == '1' && !this.showFromTime) return  this.$util.Notifi('请选择试卷开放开始时间','error','fa-exclamation-circle')
        if(this.validPeriod == '1' && !this.showUntilTime) return  this.$util.Notifi('请选择试卷开放结束时间','error','fa-exclamation-circle')
        this.editPaper(this.dataProp)
      },
       editPaper(e){
        console.log(e)
             let params = {}
             if(e.row.state == 1 ){
                params = {
                id:e.row.id,
                state:'2'
                }
             }else{
                params = {
                id:e.row.id,
                validPeriod:this.validPeriod,
                showFromTime:this.showFromTime,
                showUntilTime:this.showUntilTime
                }
             }
             editEmuPaper({
                ...params,
                businessId:this.businessInfo.id
                    },'put','enterprise')
                .then(res => {
                  if(res.code ==1){
                     this.$message.error(res.msg); 
                  }else{
                      this.$message.success('状态修改成功'); 
                       this.centerDialogVisible = false
                    this.getEmuPaperList()
                  }
                })
                .catch(err => {
                })
        },
        // 获取仿真分页列表
        getEmuPaperList(){
            let params = {
                paperName:this.search,
                id:this.search1,
                appId:this.value1,
                validPeriod:this.radio,
                state:this.radio1,
                 businessId:this.businessInfo.id,
                 current: this.currentPage,
                size:this.PageSize,
                omId:'',
            }
            getEmuPaper(params)
            .then(res =>{
            this.list = res.data.records
             this.totalCount = res.data.total;
            })
            .catch(err =>{})
        },

    }
}
</script>
<style lang="scss" scoped>

</style>